module.exports = __webpack_public_path__ + "monaco.worker.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@timkendrick/monaco-editor-loader/lib/loaders/chunkUrl.js?{}!./node_modules/@timkendrick/monaco-editor-loader/lib/loaders/compile.js?{"target":"worker","emit":true,"output":"monaco.worker.js"}!./node_modules/@timkendrick/monaco-editor-loader/lib/loaders/include.js?{"includes":["/Users/tim/Sites/@timkendrick/monaco-editor/submodules/vscode/src/vs/editor/common/services/editorSimpleWorker.ts"]}!./submodules/vscode/src/vs/base/worker/workerMain.ts
// module id = 296
// module chunks = 0